import { render, staticRenderFns } from "./InvoiceDoc.vue?vue&type=template&id=4bee36e9&scoped=true"
import script from "./InvoiceDoc.vue?vue&type=script&lang=js"
export * from "./InvoiceDoc.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDoc.vue?vue&type=style&index=0&id=4bee36e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee36e9",
  null
  
)

export default component.exports